import { create } from 'zustand';

type IStore = {
  showPlanificationEmpty: boolean;
  showPlanificationViewer: boolean;
  showPlanificationForm: boolean;
  initializeStates: (isActive: boolean) => void;
  setShowPlanificationEmpty: (show: boolean) => void;
  setShowPlanificationViewer: (show: boolean) => void;
  setShowPlanificationForm: (show: boolean) => void;
  handleCreatePlanification: () => void;
  handleCancelPlanification: () => void;
};

export const usePlanificationStates = create<IStore>(set => ({
  showPlanificationEmpty: false,
  showPlanificationViewer: false,
  showPlanificationForm: false,

  initializeStates: (isActive: boolean) => {
    set({
      showPlanificationEmpty: !isActive,
      showPlanificationViewer: isActive,
      showPlanificationForm: false
    });
  },

  setShowPlanificationEmpty: (show: boolean) => {
    set({ showPlanificationEmpty: show });
  },

  setShowPlanificationViewer: (show: boolean) => {
    set({ showPlanificationViewer: show });
  },

  setShowPlanificationForm: (show: boolean) => {
    set({ showPlanificationForm: show });
  },

  handleCreatePlanification: () => {
    set({
      showPlanificationEmpty: false,
      showPlanificationForm: true,
      showPlanificationViewer: false
    });
  },

  handleCancelPlanification: () => {
    set({
      showPlanificationForm: false,
      showPlanificationViewer: true
    });
  }
}));
